import { useIsMuted, useIsSpeaking } from '@livekit/components-react';
import { LocalParticipant, RemoteParticipant, Track } from 'livekit-client';
import { Mic, MicOff } from 'lucide-react';

export const Participant = ({ participant }: { participant: RemoteParticipant | LocalParticipant }) => {
  const isMuted = useIsMuted({ participant, source: Track.Source.Microphone });
  const isSpeaking = useIsSpeaking(participant);

  const update = () => {};

  return (
    <div
      key={participant.identity}
      className="flex gap-2 p-1 w-full items-center justify-start relative"
      onClick={update}
    >
      <div
        className={`w-8 h-8 rounded-full bg-gray-400 flex grow-0 shrink-0 items-center justify-center text-white ${
          isSpeaking ? 'animate-pulse ring-2 ring-red-500' : ''
        }`}
      >
        {participant.name &&
          participant.name
            .split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2)}
      </div>
      <div className="overflow-hidden text-ellipsis whitespace-nowrap">{participant.name}</div>
      <div className="flex absolute right-4 bg-transparent p-1 rounded w-7 h-7">{isMuted ? <MicOff /> : <Mic />}</div>
    </div>
  );
};
